import useEventUniqueName from './useEventUniqueName';

const useIsEventExperienceSummitEvent = () => {
    const eventUniqueName = useEventUniqueName();
    const isEventExperienceSummitEvent =
        eventUniqueName.toLowerCase() === 'eventexperience' ||
        eventUniqueName.toLowerCase() === 'dev_eventexperience';

    return isEventExperienceSummitEvent;
};

export default useIsEventExperienceSummitEvent;
